// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__EY5Qx","close-icon":"Modal_close-icon__3-zhR"};